import { defineStore } from "pinia"

export interface I18nState {
  language: string
}

export const useI18nStore = defineStore("i18nStore", {
  persist: true,
  state: (): I18nState => {
    return {
      language: "en"
    }
  },
  getters: {
    getLanguage(): string {
      return this.language
    }
  },
  actions: {
    setLanguage(language: string) {
      this.language = language
    }
  }
})
